// @flow
import * as React from 'react';
import type { Element } from 'react';
import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import theme from '@theme';

import type { Props } from './types';

const SIZE_STYLES = {
  SMALL: css`
    min-width: 130px;
    height: 30px;
  `,
  MEDIUM: css`
    min-width: 110px;
    height: 40px;

    ${breakpoint('desktop')`
      min-width: 150px;
    `}
  `,
  LARGE: css`
    min-width: 199px;
    height: 56px;
  `
};

const StyledButtonSecondary = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: transparent;

  ${({ size }) => SIZE_STYLES[size]}

  cursor: pointer;
  color: ${props => (props.inverted ? theme.colors.gray : theme.colors.white)};
  border: 1px solid ${theme.colors.gray};
  border-radius: 5px;

  transition: all 0.5s ease;

  font-size: 16px;

  width: ${({ full }) => (full ? '100%' : 'auto')};

  &:hover,
  &:active {
    color: ${props => (props.inverted ? theme.colors.defaultGreen : theme.colors.gray)};
    border: 1px solid ${props => (props.inverted ? theme.colors.defaultGreen : theme.colors.gray)};

    svg,
    path {
      fill: ${props => (props.inverted ? theme.colors.defaultGreen : theme.colors.gray)};
      stroke: ${props => (props.inverted ? theme.colors.defaultGreen : theme.colors.gray)};
    }
  }
`;

const StyledButtonSecondaryIcon = styled.div`
  font-size: 1.2em;
`;

const StyledButtonSecondaryIconPrefix = styled(StyledButtonSecondaryIcon)`
  margin-right: 5px;
`;

const StyledButtonSecondaryIconSuffix = styled(StyledButtonSecondaryIcon)`
  margin-left: 8px;
`;

const ButtonSecondary = ({
  type = 'button',
  inverted,
  children,
  size = 'MEDIUM',
  prefixIcon,
  suffixIcon,
  full,
  ...props
}: Props): Element<any> => (
  <StyledButtonSecondary full={full} type={type} inverted={inverted} size={size} {...props}>
    {prefixIcon && (
      <StyledButtonSecondaryIconPrefix>
        {React.cloneElement(prefixIcon, { size: '1x' })}
      </StyledButtonSecondaryIconPrefix>
    )}
    {children}
    {suffixIcon && (
      <StyledButtonSecondaryIconSuffix>
        {React.cloneElement(suffixIcon, { size: '1x' })}
      </StyledButtonSecondaryIconSuffix>
    )}
  </StyledButtonSecondary>
);

export default ButtonSecondary;
